// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2dlcT","fileBtn":"File_fileBtn__24Mbz","closeBtn":"File_closeBtn__wpLyl","fileSelected":"File_fileSelected__2_09t","disabled":"File_disabled__1G5w2"};